/* import __COLOCATED_TEMPLATE__ from './update-bank-account-flow.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import moment from 'moment-timezone';
import { gt } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
let UpdateBankAccountFlowComponent = (_dec = gt('importableExternalBankAccounts.length', 0), _class = class UpdateBankAccountFlowComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "plaidState", _descriptor2, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor3, this);
    _initializerDefineProperty(this, "sfsExternalBankAccountApi", _descriptor4, this);
    _initializerDefineProperty(this, "isLoading", _descriptor5, this);
    _defineProperty(this, "page", 'update');
    _defineProperty(this, "selectedImportableExternalBankAccount", void 0);
    _initializerDefineProperty(this, "hasImportableAccounts", _descriptor6, this);
  }
  init(...args) {
    super.init(...args);

    // If there is an external bank account that was linked within the past day, show a warning that disallows continuing.
    // Otherwise, if there is an external bank account that is currently being verified, show a warning explaining that the
    // linking will be canceled.
    // Otherwise, if there are any existing external bank accounts, go to a warning page explaining that the bank account
    // will be replaced.
    // Finally, otherwise, go to the page to update/add a new bank account.
    if (this.plaidState.isLinkLessThanOneDay || this.externalBankAccounts.some(account => moment().diff(moment(account.initiatedLinkAt), 'days') < 1)) {
      this.goToUpdatedWithinOneDayWarning();
    } else if (this.plaidState.hasVerifyingLink || this.externalBankAccounts.some(account => account.linkStatus === ExternalBankAccount.LinkStatus.VERIFYING)) {
      this.goToUpdateInProgressWarning();
    } else if (this.externalBankAccounts.length > 0) {
      // Only show the warning that the bank account will be replaced within 4 days if Plaid is not enabled,
      // since most bank accounts linked by Plaid should be instant
      this.goToUpdateOrAddExternalBankAccount();
    } else {
      this.goToUpdateOrAddExternalBankAccount();
    }
  }
  async importExternalBankAccount() {
    if (!this.selectedImportableExternalBankAccount) {
      // should be impossible
      throw new Error('Import account submitted with empty selection');
    }
    this.isLoading = true;
    try {
      await this.sfsExternalBankAccountApi.importExternalBankAccount(this.sfsCustomerApi.currentCustomer.id, this.selectedImportableExternalBankAccount);
      this.isLoading = false;
      this.goToSuccess();
    } catch {
      this.isLoading = false;
      this.goToFailedImportVerification();
    }
  }
  selectImportableExternalBankAccount(importableExternalBankAccount) {
    set(this, 'selectedImportableExternalBankAccount', importableExternalBankAccount);
  }
  goToAddExternalBankAccount() {
    set(this, 'page', 'add-external-bank-account');
  }
  goToLinkExternalBankAccountPlaid() {
    set(this, 'page', 'link-external-bank-acount-plaid');
  }
  goToUpdatedWithinOneDayWarning() {
    set(this, 'page', 'updated-within-one-day-warning');
  }
  goToUpdateInProgressWarning() {
    set(this, 'page', 'update-in-progress-warning');
  }
  goToSuccess() {
    set(this, 'page', 'success');
  }
  goToUpdate() {
    set(this, 'page', 'update');
  }
  goToFailedImportVerification() {
    set(this, 'page', 'failed-import-verification');
  }
  goToError() {
    set(this, 'page', 'error');
  }
  goToUpdateOrAddExternalBankAccount() {
    if (this.hasImportableAccounts) {
      this.selectImportableExternalBankAccount(this.importableExternalBankAccounts[0]);
      this.goToUpdate();
    } else {
      this.goToLinkExternalBankAccountPlaid();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "plaidState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sfsExternalBankAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasImportableAccounts", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "importExternalBankAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "importExternalBankAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectImportableExternalBankAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectImportableExternalBankAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToAddExternalBankAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToAddExternalBankAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToLinkExternalBankAccountPlaid", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToLinkExternalBankAccountPlaid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToUpdatedWithinOneDayWarning", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToUpdatedWithinOneDayWarning"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToUpdateInProgressWarning", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToUpdateInProgressWarning"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToFailedImportVerification", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToFailedImportVerification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToUpdateOrAddExternalBankAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToUpdateOrAddExternalBankAccount"), _class.prototype), _class);
export { UpdateBankAccountFlowComponent as default };